import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import axios from 'axios';
//UI
import { DangerButton, SuccessButton } from "../../../../ui/buttons/Button";
import { Input } from "../../../../ui/inputs/Input";
import { Mensaje } from "../../../mensajes2";

export default function UnidadFuncional({ show, setShow, onRecargar, operacion, id }) {
  var op = require('../../../../modulos/datos');
  let token = localStorage.getItem('jwtToken');

  const [formData, setFormData] = useState({
    coduni: '',
    nomuni: '',
    sector: '',
    programa: '',
    subprograma: '',
    proyecto: '',
    actividad: '',
    descSector: '',
    descPrograma: '',
    descSubprograma: '',
    descProyecto: '',
    descActividad: ''
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });

  // Cargar datos si es edición o consulta
  useEffect(() => {
    if (show && (operacion === 2 || operacion === 3 || operacion === 4) && id) {
      cargarDatosUnidad();
    } else if (show && operacion === 1) {
      // Limpiar formulario para nueva unidad
      setFormData({
        coduni: '',
        nomuni: '',
        sector: '',
        programa: '',
        subprograma: '',
        proyecto: '',
        actividad: '',
        descSector: '',
        descPrograma: '',
        descSubprograma: '',
        descProyecto: '',
        descActividad: ''
      });
    }
  }, [show, operacion, id]);

  const cargarDatosUnidad = async () => {
    setLoading(true);
    let codigoNomina = localStorage.getItem('codigonomina');
    codigoNomina = codigoNomina ? codigoNomina.replace(/"/g, '') : '';

    let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=*&nomtab=nomi${codigoNomina}.unidadfuncional&condi=coduni='${id.toString()}'&orden=coduni`;

    try {
      const response = await axios.get(endpoint, {
        headers: { "x-access-token": `${token}` }
      });
      console.log('Respuesta al cargar unidad:', response.data);
      if (response.status === 200 && response.data && response.data.length > 0) {
        const unidad = response.data[0];
        setFormData({
          coduni: unidad.coduni || '',
          nomuni: unidad.nomuni ? unidad.nomuni.trim() : '',
          sector: unidad.sector || '',
          programa: unidad.progra || '',  // Nota: viene como 'progra' no 'programa'
          subprograma: unidad.subprogra || '',  // Nota: viene como 'subprogra'
          proyecto: unidad.proye || '',  // Nota: viene como 'proye'
          actividad: unidad.activi || '',  // Nota: viene como 'activi'
          descSector: unidad.dessec ? unidad.dessec.trim() : '',
          descPrograma: unidad.despro ? unidad.despro.trim() : '',
          descSubprograma: unidad.dessubpro ? unidad.dessubpro.trim() : '',
          descProyecto: unidad.desproye ? unidad.desproye.trim() : '',
          descActividad: unidad.desact ? unidad.desact.trim() : ''
        });
      }
    } catch (error) {
      console.error('Error al cargar unidad:', error);
      setError('Error al cargar los datos');
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async () => {
    if (operacion === 3) {
      await eliminarUnidad();
    } else {
      await guardarUnidad();
    }
  };

  const guardarUnidad = async () => {
    if (!formData.coduni || !formData.nomuni) {
      setError('Código y Nombre son obligatorios');
      return;
    }

    setLoading(true);
    let codigoNomina = localStorage.getItem('codigonomina');
    codigoNomina = codigoNomina ? codigoNomina.replace(/"/g, '') : '';

    let endpoint = `${op.conexion}/api/nomina/unidadfuncional_act`;

    let data = {
      operacion: operacion,
      esquema1: `nomi${codigoNomina}`,
      ccoduni: formData.coduni,
      cnomuni: formData.nomuni,
      csector: formData.sector,
      cdessec: formData.descSector,
      cprogra: formData.programa,
      cdespro: formData.descPrograma,
      cactivi: formData.actividad,
      cdesact: formData.descActividad

    };

    try {
      const response = await axios.post(endpoint, data, {
        headers: { "x-access-token": `${token}` }
      });

      if (response.status === 200) {

        setMensaje({
          mostrar: true,
          titulo: 'Información',
          texto: 'Operación realizada exitosamente',
          icono: 'exito'
        });


      }
    } catch (error) {
      console.error('Error al guardar:', error);
      setError(error.response?.data?.message || 'Error al guardar la unidad');
    } finally {
      setLoading(false);
    }
  };

  const eliminarUnidad = async () => {
    setLoading(true);
    let codigoNomina = localStorage.getItem('codigonomina');
    codigoNomina = codigoNomina ? codigoNomina.replace(/"/g, '') : '';

    let endpoint = `${op.conexion}/api/consulta/sp_unidadfuncional`;
    let data = {
      opcion: 'ELIMINAR',
      codigonomina: codigoNomina,
      coduni: id
    };

    try {
      const response = await axios.post(endpoint, data, {
        headers: { "x-access-token": `${token}` }
      });

      if (response.status === 200) {
        if (onRecargar) onRecargar();
        setShow(false);
      }
    } catch (error) {
      console.error('Error al eliminar:', error);
      setError(error.response?.data?.message || 'Error al eliminar la unidad');
    } finally {
      setLoading(false);
    }
  };

  const salir = () => {
    setShow(false);
    setError('');
  };

  const getTitulo = () => {
    switch (operacion) {
      case 1: return "Crear Unidad Funcional";
      case 2: return "Editar Unidad Funcional";
      case 3: return "Eliminar Unidad Funcional";
      case 4: return "Consultar Unidad Funcional";
      default: return "Unidad Funcional";
    }
  };

  const isDisabled = operacion === 3 || operacion === 4;
  const isReadOnly = operacion === 4;

  return (
    <Modal size="lg" show={show} centered backdrop="static" keyboard={false}>
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top">
        <h3 className="fw-bold m-0">{getTitulo()}</h3>
        <a type="button" className="fw-bold text-light fs-6" onClick={salir} style={{ cursor: 'pointer' }}>
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body className="col-12 m-0 p-2 d-flex flex-wrap">
        {error && (
          <div className="col-12 alert alert-danger mb-2" role="alert">
            {error}
          </div>
        )}
        <div className="col-3 m-0 p-0">
          <Input
            label="Cod. Unidad:"
            name="coduni"
            value={formData.coduni}
            onChange={handleInputChange}
            disabled={isDisabled}
            readOnly={isReadOnly}
          />
        </div>
        <div className="col-9 m-0 p-0 pl-2">
          <Input
            label="Nombre:"
            name="nomuni"
            value={formData.nomuni}
            onChange={handleInputChange}
            disabled={isDisabled}
            readOnly={isReadOnly}
          />
        </div>
        <fieldset className="col-12 m-0 mb-2 p-2 d-flex border rounded mt-2">
          <legend className="float-none w-auto m-0 px-2">
            Cargar Categoria Programatica
          </legend>
          <div className="col-3 m-0 p-0 d-flex flex-column gap-2">
            <Input
              label="Sector:"
              name="sector"
              value={formData.sector}
              onChange={handleInputChange}
              disabled={isDisabled}
              readOnly={isReadOnly}
              maxLength={2}
            />
            <Input
              label="Programa:"
              name="programa"
              value={formData.programa}
              onChange={handleInputChange}
              disabled={isDisabled}
              readOnly={isReadOnly}
              maxLength={2}
            />
            <Input
              label="SubPrograma:"
              name="subprograma"
              value={formData.subprograma}
              onChange={handleInputChange}
              disabled={isDisabled}
              readOnly={isReadOnly}
              maxLength={2}
            />
            <Input
              label="Proyecto:"
              name="proyecto"
              value={formData.proyecto}
              onChange={handleInputChange}
              disabled={isDisabled}
              readOnly={isReadOnly}
              maxLength={2}
            />
            <Input
              label="Actividad:"
              name="actividad"
              value={formData.actividad}
              onChange={handleInputChange}
              disabled={isDisabled}
              readOnly={isReadOnly}
              maxLength={2}
            />
          </div>
          <div className="col-9 m-0 p-0 pl-2 d-flex flex-column gap-2">
            <Input
              label="Descripción Sector:"
              name="descSector"
              value={formData.descSector}
              onChange={handleInputChange}
              disabled={isDisabled}
              readOnly={isReadOnly}
            />
            <Input
              label="Descripción Programa:"
              name="descPrograma"
              value={formData.descPrograma}
              onChange={handleInputChange}
              disabled={isDisabled}
              readOnly={isReadOnly}
            />
            <Input
              label="Descripción SubPrograma:"
              name="descSubprograma"
              value={formData.descSubprograma}
              onChange={handleInputChange}
              disabled={isDisabled}
              readOnly={isReadOnly}
            />
            <Input
              label="Descripción Proyecto:"
              name="descProyecto"
              value={formData.descProyecto}
              onChange={handleInputChange}
              disabled={isDisabled}
              readOnly={isReadOnly}
            />
            <Input
              label="Descripción Actividad:"
              name="descActividad"
              value={formData.descActividad}
              onChange={handleInputChange}
              disabled={isDisabled}
              readOnly={isReadOnly}
            />
          </div>


          <Mensaje
            mensaje={mensaje}
            onHide={() => {
              if (mensaje.icono === 'exito') {
                setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                if (onRecargar) onRecargar();
                setShow(false);
              } else { setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' }) }
            }}
          />

        </fieldset>
      </Modal.Body>
      <Modal.Footer>
        {operacion !== 4 && (
          <SuccessButton onClick={handleSubmit} disabled={loading}>
            {loading ? 'Procesando...' : (operacion === 3 ? 'Eliminar' : 'Aceptar')}
          </SuccessButton>
        )}
        <DangerButton onClick={salir} disabled={loading}>
          Cancelar
        </DangerButton>
      </Modal.Footer>
    </Modal>
  );
}